import {NgModule} from '@angular/core';
import {LoginPageComponent} from './login-page/login-page.component';
import {SharedModule} from '../shared/shared.module';
import {PageNotFoundComponent} from './page-not-found/page-not-found.component';


@NgModule({
  declarations: [LoginPageComponent,
  PageNotFoundComponent],
  imports: [
    SharedModule,



  ]
})
export class AuthModule { }
